import { ThemeProvider as ZDSThemeProvider, ThemeProviderProps as ZDSThemeProviderProps } from '@croquiscom-pvt/zds';

export interface ThemeProviderProps extends ZDSThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = (props: ThemeProviderProps) => {
  const { children, ...restProps } = props;
  // colorScheme이 안들어오는 케이스가 존재하여 기본값을 설정
  const rest_props = {
    ...restProps,
    colorScheme: restProps.colorScheme || 'system',
  };
  return <ZDSThemeProvider {...rest_props}>{children}</ZDSThemeProvider>;
};
